import {
  getList,
  getObject,
} from "@surya-digital/leo-ts-types";
import { SurveyDashboardView, SurveyDashboardViewDTO } from "./surveyDashboardView";
import { SurveyStatusAndName, SurveyStatusAndNameDTO } from "../types/surveyStatusAndName";

export interface SurveyDetailsAndDashboardViewsDTO {
  surveyDashboardViews: SurveyDashboardViewDTO[];
  surveyStatusAndName: SurveyStatusAndNameDTO;
}

export class SurveyDetailsAndDashboardViews {
  readonly isSurveyDetailsAndDashboardViewsSurveyDetailsAndDashboardViews: boolean = true;

  readonly surveyDashboardViews: SurveyDashboardView[];
  readonly surveyStatusAndName: SurveyStatusAndName;


  constructor(
  surveyDashboardViews: SurveyDashboardView[], 
  surveyStatusAndName: SurveyStatusAndName
  ) {
    this.surveyDashboardViews = surveyDashboardViews;
    this.surveyStatusAndName = surveyStatusAndName;
  }

  static fromDTO(dto: SurveyDetailsAndDashboardViewsDTO): SurveyDetailsAndDashboardViews {
    const surveyDashboardViews = getList<SurveyDashboardViewDTO, SurveyDashboardView>(
      dto,
      "surveyDashboardViews",
      SurveyDashboardView.fromDTO,
      InvalidSurveyDetailsAndDashboardViewsSurveyDashboardViewsError
    );
    const surveyStatusAndName = SurveyStatusAndName.fromDTO(getObject(dto, "surveyStatusAndName", InvalidSurveyDetailsAndDashboardViewsSurveyStatusAndNameError));
    return new SurveyDetailsAndDashboardViews(
      surveyDashboardViews,
      surveyStatusAndName
    );
  }

  toDTO(): SurveyDetailsAndDashboardViewsDTO {
    const dto: SurveyDetailsAndDashboardViewsDTO = {
        surveyDashboardViews: this.surveyDashboardViews.map((e: SurveyDashboardView) => { return e.toDTO() }),
        surveyStatusAndName: this.surveyStatusAndName.toDTO()
    };
    return dto;
  }
  }

SurveyDetailsAndDashboardViews.prototype.toString = function toString(): string {
  return `SurveyDetailsAndDashboardViews(surveyDashboardViews='${this.surveyDashboardViews}',surveyStatusAndName='${this.surveyStatusAndName}')`;
};

export class InvalidSurveyDetailsAndDashboardViewsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyDetailsAndDashboardViewsError";
  }
}
export class InvalidSurveyDetailsAndDashboardViewsSurveyDashboardViewsError extends InvalidSurveyDetailsAndDashboardViewsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyDetailsAndDashboardViewsSurveyDashboardViewsError";
  }
}

export class InvalidSurveyDetailsAndDashboardViewsSurveyStatusAndNameError extends InvalidSurveyDetailsAndDashboardViewsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyDetailsAndDashboardViewsSurveyStatusAndNameError";
  }
}
